<template>
    <div class="flex flex-col">
        <div class="toggler hover:text-primary cursor-pointer opacity-70 hover:opacity-100 font-semibold w-fit" @click="show = !show">
            <i class="i-ph-eye inline-block text-xl -mb-1 mr-1 transition-all" :style="show ? 'opacity: 100%': 'opacity: 50%'"/>
            {{ show ? 'Skjul' : 'Vis' }} JSON Data
        </div>
        <div class="overflow-auto text-xs whitespace-pre transition-all p-1" :style="show? 'max-height: 100vh; border: 1px solid #c0c0c0;': 'max-height: 0vh; opacity: 0;'">
            {{ JSON.stringify(data, null, 2) }}
        </div>
    </div>
</template>

<script setup lang="ts">
import {useStorage} from '@vueuse/core'

defineProps({
    data: {
        type: Object,
        required: false,
        default: () => {}
    }
})

const show = useStorage('showDebugJson', false)
</script>

<style scoped>

</style>